import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const TableContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: ${theme.spacing.lg};
`;
